import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { FiltroIndicadoresVisitas } from "./FiltroIndicadoresVisitas";
import { IndicadoresVisitasTabla } from "./IndicadoresVisitasTabla";
import { IndicadoresVisitasCRMService, extraerMensajeError } from "./IndicadoresVisitasCRMService";
import GetAppIcon from "@mui/icons-material/GetApp";

const MESES_LABEL = [
    "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
    "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE",
];

// Texto del título según el filtro "Tipo" ("P"/"R") — ver FiltroIndicadoresVisitas.
const TIPO_LABEL = { P: "PROGRAMADAS", R: "REALIZADAS" };

/**
 * IndicadoresVisitasMainScreen
 * Reporte de solo lectura: visitas realizadas por semana durante el mes, contra el objetivo
 * mensual/semanal de cada vendedor. Mismo patrón de header que los demás reportes CRM
 * (Regresar + Filtro a la izquierda, botón "Excel" a la derecha que descarga
 * IndicadoresVisitas/ImprimirExcelReporteVisitas con el ejercicio/periodo/tipo del filtro
 * actual). El filtro (Ejercicio/Mes/Tipo) es una réplica de FiltroObjetivosMensuales con un campo
 * propio de este reporte: "Tipo" (Programadas/Realizadas), que el backend recibe como
 * "linea" ("P"/"R"); por default entra como "P" (Programadas).
 */
const IndicadoresVisitasMainScreen = () => {
    const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });
    const history = useHistory();

    const [filtro, setFiltro] = useState({
        ejercicio: new Date().getFullYear(),
        mes: new Date().getMonth() + 1,
        tipo: "P",
    });
    const [datos, setDatos] = useState([]);

    const cargarReporte = (ejercicio, periodo, tipo) => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        IndicadoresVisitasCRMService.reporteVisitas(ejercicio, periodo, tipo)
            .then((result) => {
                setDatos(Array.isArray(result) ? result : []);
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setDatos([]);
                Swal.fire("INDICADORES DE VISITAS", extraerMensajeError(error), "error");
            });
    };

    useEffect(() => {
        cargarReporte(filtro.ejercicio, filtro.mes, filtro.tipo);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onCargar = (ejercicio, mes, tipo) => {
        setFiltro({ ejercicio, mes, tipo });
        cargarReporte(ejercicio, mes, tipo);
    };

    // Descarga el Excel del reporte actual (mismo ejercicio/periodo/tipo del filtro) — el backend
    // regresa { documento (base64), filename }, mismo patrón que los demás reportes CRM.
    const onGenerarExcel = () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        IndicadoresVisitasCRMService.imprimirExcel(filtro.ejercicio, filtro.mes, filtro.tipo)
            .then(({ documento, filename }) => {
                const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
                const downloadLink = document.createElement("a");
                downloadLink.href = linkSource;
                downloadLink.download = `${filename}.xlsx`;
                downloadLink.click();
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch((error) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("INDICADORES DE VISITAS", extraerMensajeError(error), "error");
            });
    };


    return (
        <div className="crm-main-screen">
            <LoaderScreen loader={loader} />
            <div className="crm-body">
                <div className="crm-page rca-screen">
                    <div className="crm-module">
                        <div className="crm-module-head">
                            <div className="crm-head-grid">
                                <div className="crm-head-left">
                                    <button className="crm-btn-regresar" onClick={() => history.goBack()} aria-label="Regresar">
                                        <ArrowBackIcon /> <span className="crm-btn-label">Regresar</span>
                                    </button>
                                    <FiltroIndicadoresVisitas onCargar={onCargar} ejercicio={filtro.ejercicio} mes={filtro.mes} tipo={filtro.tipo} />
                                </div>
                                <div className="crm-head-center">
                                    {/* <p className="crm-module-subtitle">Reportes</p> */}
                                    <h1 className="crm-module-title">
                                        INDICADORES DE VISITAS {TIPO_LABEL[filtro.tipo] || TIPO_LABEL.P} - {MESES_LABEL[filtro.mes - 1]} {filtro.ejercicio}
                                    </h1>
                                </div>
                                <div className="crm-head-right">
                                    <button className="crmcs-btn-excel" onClick={onGenerarExcel} aria-label="Excel">
                                        <GetAppIcon /> <span className="crm-btn-label">Excel</span>
                                    </button>
                                </div>
                            </div>
                            <div className="crm-head-divider">
                                <div className="crm-head-divider-dot" />
                            </div>
                        </div>

                        <div className="crm-home-wrapper rca-wrapper scroll">
                            <IndicadoresVisitasTabla
                                datos={datos}
                                cargando={loader.mostrar}
                                ejercicio={filtro.ejercicio}
                                periodo={filtro.mes}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IndicadoresVisitasMainScreen;
